<div ngClass="loading-page">
    <mat-spinner
        strokeWidth="4"
        [diameter]="diameter"
        [color]="color"></mat-spinner>
</div>
